import { getItem, setItem, STORAGE_KEYS } from "@/lib/localstorage";
import pkg from "@/package.json";
import axios from "axios";

export enum AppName {
  ASTROLEARN = "ASTROLEARN",
}

export interface UserEvent {
  id: string;
  userId: string;
  eventGeneratedId: string | null;
  eventName: string;
  appName: AppName;
  metaData: Record<string, any> | null;
  createdAt: Date;
  updatedAt: Date;
}

export type UserLoginSchema = {
  appName: AppName;
  metaData: Record<string, any> | null;
  eventGeneratedId: string | null;
  name: string;
  phone: string;
  email: string | null;
};

export type UserEventSchema = {
  userId: string;
  eventName: string;
  appName: AppName;
  metaData: Record<string, any> | null;
};

export const UserEventLogger = async (
  eventName: string,
  data?: UserEventSchema["metaData"]
): Promise<void> => {
  const userId = getItem(STORAGE_KEYS.TFU_LOGGER_USER_ID);
  const eventGeneratedId = getItem(STORAGE_KEYS.TFU_LOGGER_GENERATED_ID);

  const appName = AppName.ASTROLEARN;
  try {
    const reponse = await axios.post<{ message: string; data: UserEvent }>(
      `${process.env.NEXT_PUBLIC_EVENT_LOGGER_URL}event/create`,
      {
        eventName,
        appName,
        metaData: {
          ...data,
          project_name: pkg.name,
          page_url: window.location.href,
          ...(document.referrer ? { page_referrer: document.referrer } : {}),
        },
        ...(userId && { userId }),
        ...(eventGeneratedId && !userId ? { eventGeneratedId } : {}),
      }
    );

    if (!userId && !eventGeneratedId && reponse.data.data.eventGeneratedId) {
      setItem(
        STORAGE_KEYS.TFU_LOGGER_GENERATED_ID,
        reponse.data.data.eventGeneratedId
      );
    }
  } catch (error) {
    console.error(error);
  }
};

export const UserLogin = async (data: {
  name: string;
  phone: string;
  email?: string;
}): Promise<void> => {
  const userId = getItem(STORAGE_KEYS.TFU_LOGGER_USER_ID);

  if (userId) return;

  const eventGeneratedId = getItem(STORAGE_KEYS.TFU_LOGGER_GENERATED_ID);

  const appName = AppName.ASTROLEARN;

  const payload: UserLoginSchema = {
    appName,
    metaData: null,
    eventGeneratedId: eventGeneratedId ?? null,
    name: data.name,
    phone: data.phone,
    email: data.email ?? null,
  };

  try {
    const { data: reponse } = await axios.post<{ data: UserEvent }>(
      `${process.env.NEXT_PUBLIC_EVENT_LOGGER_URL}event/login`,
      payload
    );
    const typedResponse = reponse.data;

    if (typedResponse.userId) {
      setItem(STORAGE_KEYS.TFU_LOGGER_USER_ID, typedResponse.userId);
    }
  } catch (error) {
    console.error(error);
  }
};
